<script>
    import {Doughnut} from 'vue-chartjs'

    export default {
        extends: Doughnut,
        name: "DoughnutChart",
        props: [
            'chartData'
        ],
        data() {
            return {
                chartOptions: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    },
                    hover: {mode: null},
                    cutoutPercentage: 30,
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 20,
                            bottom: 20
                        }
                    },
                },
            }
        },
        mounted() {
            this.renderChart(this.chartData, this.chartOptions)
        },
    }
</script>